import React from 'react';
import ReactPlayer from 'react-player';
import Dialog, { DialogContent } from 'material-ui/Dialog';
class AdsDialog extends React.Component {
  constructor() {
    super();
    this.state = {
      open: false,
    };
  }

  handleClickOpen = () => {
    this.setState({
      open: true,
    });
  };

  handleClose = value => {
    this.setState({ open: false });
  };

  render() {
    const lang = localStorage.getItem('i18nextLng');
    let langvidep;
    if (lang === 'fr' || lang === 'fr-FR') {
      langvidep = (
        <ReactPlayer
          url="https://youtu.be/KmLJOuZDNKY"
          playing={this.state.playing}
          controls={true}
          width={'100%'}
          height={410}
        />
      );
    } else if (lang === 'en' || lang === 'en-US') {
      langvidep = (
        <ReactPlayer
          url="https://youtu.be/RsEmqJxU2gI"
          playing={this.state.playing}
          controls={true}
          width={'100%'}
          height={410}
        />
      );
    }
    return (
      <div>
        <li
          style={{ cursor: `pointer`, top: 75 }}
          onClick={this.handleClickOpen}
          className="usinbtn"
        />

        <div>
          <Dialog
            fullWidth
            open={this.state.open}
            onClose={this.handleClose}
            aria-labelledby="simple-dialog-title"
          >
            <DialogContent
              id="dialog_1"
              style={{ padding: `0`, overflow: `hidden`, marginBottom: `-3px` }}
            >
              {langvidep}
            </DialogContent>
          </Dialog>
        </div>
      </div>
    );
  }
}

export default AdsDialog;



// WEBPACK FOOTER //
// ./src/components/App/Ads.js